import React, { useState } from 'react';

const PageGallery = () => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Aquí puedes agregar la lógica para subir la imagen al servidor
    console.log('Archivo seleccionado:', selectedFile);
  };

  return (
    <div>
      <h1>Subir Foto a la Galería</h1>
      <form onSubmit={handleSubmit}>
        <input type="file" onChange={handleFileChange} />
        <button type="submit">Subir</button>
      </form>
    </div>
  );
};

export default PageGallery;